"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFurthestDate = getFurthestDate;
exports.getEarliestDate = getEarliestDate;
function getFurthestDate(dates) {
    return getEdgeDate(dates, true);
}
function getEarliestDate(dates) {
    return getEdgeDate(dates, false);
}
function getEdgeDate(dates, findFurthest) {
    // In case of empty array, return current date
    if (dates.length === 0) {
        return new Date();
    }
    let edgeDate = new Date(dates[0]).getTime();
    for (let i = 1; i < dates.length; i++) {
        const dateInMs = new Date(dates[i]).getTime();
        const isFurther = dateInMs > edgeDate;
        if (findFurthest === isFurther) {
            edgeDate = dateInMs;
        }
    }
    return new Date(edgeDate);
}
//# sourceMappingURL=getFurthestDate.js.map